import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./ModuleSubtopic1.css";
import { FaFilePdf } from "react-icons/fa"; // PDF icon
import NavigationButtons from "./components/NavigationButtons";
import { useSubtopicNavigation } from "./hooks/useSubtopicNavigation";

const VideoList = ({ videos, onVideoClick }) => (
  <div className="subtopic-video-list">
    {videos.map((video, index) => (
      <div
        key={index}
        className="subtopic-video-wrapper"
        onClick={() => onVideoClick(video)}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => e.key === "Enter" && onVideoClick(video)}
      >
        <iframe
          key={index}
          src={video}
          allowFullScreen
          title={`Video ${index + 1}`}
          className="subtopic-video-frame"
        ></iframe>
      </div>
    ))}
  </div>
);

const QPhototModuleSubtopic = ({ title, videos, pdfLink, takeaways, questions, exampleVideos, subtopics, subjectPath }) => {
  const [expandedVideo, setExpandedVideo] = useState(null);
  const location = useLocation();

  // Extract navigation data from location.state with defaults
  const navSubtopics = subtopics || location.state?.subtopics || [];
  const navSubjectPath = subjectPath || location.state?.subjectPath || '';

  // Get navigation paths from hook
  const { prevPath, nextPath, handleBack } = useSubtopicNavigation(
    navSubtopics,
    location.pathname,
    navSubjectPath
  );
  return (
    <div className="subtopic-main">
      <div className="subtopic-container">
        <div className="subtopic-header">{title}</div>

        {/* ✅ PDF Section */}
        {pdfLink && (
          <div className="subtopic-section">
            <h2>Resources</h2>
            <a
              href={pdfLink}
              target="_blank"
              rel="noopener noreferrer"
              className="pdf-btn"
            >
              <FaFilePdf size={20} style={{ marginRight: "8px" }} />
              Numerical problems PDF
            </a>
          </div>
        )}

        {videos.length > 0 && (
          <div className="subtopic-section">
            <h2>Videos</h2>
            <VideoList videos={videos} onVideoClick={setExpandedVideo} />
          </div>
        )}

        {takeaways.length > 0 && (
          <div className="subtopic-section">
            <h2>Key Takeaways</h2>
            {takeaways.map((item, index) => (
              <div key={index} className="takeaway-item">
                <p>- {item.text}</p>
                {item.image && <img src={item.image} alt={`Takeaway ${index + 1}`} className="takeaway-image" />}
              </div>
            ))}
          </div>
        )}

        {questions.length > 0 && (
          <div className="subtopic-section">
            <h2>Previous Questions</h2>
            {questions.map((question, index) => (
              <div key={index} className="question-item">
                <p>- {question.text}</p>
                {question.image && <img src={question.image} alt={`Question ${index + 1}`} className="question-image" />}
              </div>
            ))}
          </div>
        )}

        {exampleVideos.length > 0 && (
          <div className="subtopic-section">
            <h2>Example Question Videos</h2>
            <VideoList videos={exampleVideos} onVideoClick={setExpandedVideo} />
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      {navSubjectPath && (
        <NavigationButtons
          prevPath={prevPath}
          nextPath={nextPath}
          onBack={handleBack}
          subjectPath={navSubjectPath}
          subtopics={navSubtopics}
        />
      )}

      {/* Video Modal Overlay */}
      {expandedVideo && (
        <div
          className="video-modal-overlay"
          onClick={() => setExpandedVideo(null)}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === "Escape" && setExpandedVideo(null)}
        >
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="video-modal-close"
              onClick={() => setExpandedVideo(null)}
              aria-label="Close video"
            >
              ✕
            </button>
            <iframe
              src={expandedVideo}
              allowFullScreen
              title="Expanded Video"
              className="video-modal-iframe"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default QPhototModuleSubtopic;
